import { FormikField } from '@ahmdigital/ui';
import { map, toLower } from 'lodash/fp';
import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';

import { TYPE_LABEL } from '../../../../ahm-constants/ui';
import selectCustomer from '../../../../selectors/select-customer';
import uncapFpIterator from '../../../../../utils/uncap-fp-iterator';

type ProductTypeFieldProps = {
  handleChangeProductType?: Function;
};

const mapWithKey = uncapFpIterator(map);

const defaultCoverTypes = mapWithKey(
  (type: string, key: string) => ({
    text: type,
    value: toLower(key),
  }),
  TYPE_LABEL,
);

const ProductTypeField = ({ handleChangeProductType }: ProductTypeFieldProps) => {
  const { productType: customerProductType } = useSelector(selectCustomer);

  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    const productType = customerProductType === PRODUCT_TYPE.COMBINED ? PRODUCT_TYPE.PACKAGE : customerProductType;
    if (productType) {
      setFieldValue('productType', productType);
      if (handleChangeProductType) {
        handleChangeProductType(productType);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerProductType, setFieldValue]);

  return (
    <FormikField
      inputVariant={['button', 'fullWidth']}
      label="Select your health cover type"
      name="productType"
      options={[{ text: 'Please select', value: '' }, ...defaultCoverTypes]}
      // @ts-expect-error - Automatic, Please fix when editing this file
      onChange={({ target: { value } }) => {
        setFieldValue('productType', value);
        if (handleChangeProductType) {
          handleChangeProductType(value);
        }
      }}
      size="auto"
      type="dropdown"
    />
  );
};

export default ProductTypeField;
